import React from "react";
import {
  List,
  Filter,
  Datagrid,
  EditButton,
  TextInput,
  TextField,
  NumberField,
} from "react-admin";
import * as XLSX from "xlsx";

const ClientsTitle = () => {
  return <span>Listado de Clientes</span>;
};

const ClientsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Buscar nombre" source="name" alwaysOn />
    <TextInput label="CUIT" source="cuit" />
    <TextInput label="Email" source="email" />
    <TextInput label="Teléfono" source="phone" />
    <TextInput label="Estado" source="status" />
  </Filter>
);

const clientsExporter = (data) => {
  const exportData = data.map((record) => ({
    ID: record.id,
    CUIT: record.cuit || "-",
    Nombre: record.name,
    Email: record.email || "-",
    Teléfono: record.phone || "-",
    Estado: record.status || "-",
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(exportData);

  const colWidths = Object.keys(exportData[0]).map((h) => ({
    wch: Math.max(h.length, 15),
  }));
  ws["!cols"] = colWidths;

  XLSX.utils.book_append_sheet(wb, ws, "Clientes");
  XLSX.writeFile(wb, `clientes-${new Date().toISOString().split("T")[0]}.xlsx`);
};

export const ClientsList = (props) => (
  <List
    filters={<ClientsFilter />}
    title={<ClientsTitle />}
    {...props}
    sort={{ field: "id", order: "ASC" }}
    exporter={clientsExporter}
  >
    <Datagrid rowClick="edit">
      <NumberField source="id" label="ID" />
      <TextField source="cuit" label="CUIT" />
      <TextField source="name" label="Nombre" />
      <TextField source="email" label="Email" />
      <TextField source="phone" label="Teléfono" />
      <TextField source="status" label="Estado" />
      <EditButton />
    </Datagrid>
  </List>
);
